import { withInstall } from '@xzx-design/utils'
import _Sidebar from './src/sidebar'
import _SidebarItem from './src/sidebar-item'

export const Sidebar = withInstall(_Sidebar)
export const SidebarItem = withInstall(_SidebarItem)
export default Sidebar

export * from './src/sidebar'
export * from './src/sidebar-item'
export * from './src/types'
